export const IMAGE_URLS = {
    MARKER_ICON: 'https://www.fishipedia.fr/wp-content/uploads/2021/02/Groupe-117.png'
};

export const ORIGIN_TYPES = {
    AEM: 'AEM',
    MAGENTO: 'MAGENTO',
    REACT: 'REACT',
};
export const FORMAT_TYPES = {
    MOBILE: 'MOBILE',
    TABLET: 'TABLET',
    DESKTOP: 'DESKTOP',
    WIDE: 'WIDE',
    FULL: 'FULL',
};
export const FORMAT_SIZES = {
    MOBILE: 320,
    TABLET: 768,
    DESKTOP: 1024,
    WIDE: 1280,
    FULL: 2000,
};